import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiShield, FiFolder } = FiIcons;

const WhyChoose = () => {
  const features = [
    { 
      icon: FiClock, 
      title: 'Tepat Waktu', 
      description: 'Pekerjaan selesai sesuai deadline yang telah disepakati.' 
    },
    { 
      icon: FiShield, 
      title: 'Aman & Rahasia', 
      description: 'Privasi dan keamanan data penelitian Anda adalah prioritas kami.' 
    },
    { 
      icon: FiFolder, 
      title: 'Solutif', 
      description: 'Layanan yang fleksibel dan disesuaikan dengan kebutuhan spesifik Anda.' 
    }
  ];

  return (
    <section className="py-24 bg-white border-t border-divider">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-primary/5 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={feature.icon} className="w-8 h-8 text-primary" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-4">{feature.title}</h3>
              <p className="text-secondary leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;